module.exports = __webpack_public_path__ + "static/img/A2E_Cambodia_5150_2017SSD.5e0ed4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/A2E_Cambodia_5150_2017SSD.jpg
// module id = v5Qw
// module chunks = 0